/* tslint:disable */

/**
 */
export class AppNotify {
    id?: number;
    name?: string;
    url_img?: string;
    description?: string;
    content?: string;
    weigth?: number;
}
